import * as http from '../request/http';
import { useCallback, useMemo } from 'react';
import { useFetchPortalBrandKits } from './useFetchPortalBrandKits';
import { BRAND_KIT_COLORS_ENDPOINT } from '../constants/brandKits';
import { useAsyncFetcher } from '../asyncData/useAsyncFetcher';
import { isSucceeded } from '../asyncData/AsyncData';
const fetchBrandKitColors = brandKitId => http.get(BRAND_KIT_COLORS_ENDPOINT, {
  query: {
    brandKitId
  }
}).then(res => res.toJS());
const fetcher = brandKits => {
  const colorPromises = brandKits.map(kit => fetchBrandKitColors(kit.id));
  return Promise.all(colorPromises);
};
const getResultFormatter = brandKits => result => {
  const brandKitMap = {};
  brandKits.forEach(brandKit => {
    brandKitMap[brandKit.id] = brandKit;
  });
  result.forEach(brandColorPalette => {
    if (brandColorPalette.length > 0) {
      const kitId = brandColorPalette[0].brandKitId;
      brandKitMap[kitId].colorPalette = brandColorPalette;
    }
  });
  return brandKitMap;
};
export const useFetchBrandKitsWithColors = (deferFetcher = false) => {
  const brandKitsData = useFetchPortalBrandKits(deferFetcher);
  const brandKits = useMemo(() => {
    if (isSucceeded(brandKitsData)) {
      return brandKitsData.data;
    }
    return Array();
  }, [brandKitsData]);
  const shouldDefer = useMemo(() => deferFetcher || !isSucceeded(brandKitsData), [brandKitsData, deferFetcher]);
  const brandKitsWithColorsFetcher = useCallback(() => fetcher(brandKits), [brandKits]);
  const brandKitsWithColorsResultFormatter = useCallback(result => getResultFormatter(brandKits)(result), [brandKits]);
  const brandKitsWithColorsData = useAsyncFetcher({
    fetcher: brandKitsWithColorsFetcher,
    resultFormatter: brandKitsWithColorsResultFormatter,
    deferred: shouldDefer
  });
  return brandKitsWithColorsData;
};